import useCashboxStore, { STATUS_OPEN } from "./use-cashbox-store";

let cashboxFetched = false;

const getActionCards = (handleOpen, navigate, actions = {}) => {
    const store = useCashboxStore.getState();
    const { cashboxStatus, fetchCashbox } = store;

    if (!cashboxFetched && cashboxStatus === null) {
        cashboxFetched = true;
        fetchCashbox();
    }
    const isCashboxOpen = cashboxStatus === STATUS_OPEN;
    return [
        {
            id: "incomes-expenses",
            title: "Ingresos y egresos",
            disabled: !isCashboxOpen,
            dropdownItems: [
                {
                    group: [
                        {
                            label: "Recibos de caja",
                            onClick: () => handleOpen("receipt"),
                            tooltip: {
                                title: "Recibo de caja",
                                description:
                                    "Registra el pago total o parcial de un cliente y consulta su deuda pendiente.",
                            },
                        },
                        {
                            label: "Registro de venta",
                            onClick: () => handleOpen("sale"),
                            tooltip: {
                                title: "Registro de venta",
                                description: "Realiza la venta de un producto o servicio a un cliente.",
                            },
                        },
                    ],
                },
                {
                    group: [
                        {
                            label: "Compras",
                            onClick: () => handleOpen("purchase"),
                            tooltip: {
                                title: "Compras",
                                description:
                                    "Registra pagos a proveedores o servicios, incluyendo saldo pendiente.",
                            },
                        },
                        {
                            label: "Comprobante de pago",
                            onClick: () => handleOpen("payment"),
                            tooltip: {
                                title: "Comprobante de pago",
                                description:
                                    "Registra pagos de deudas pendientes a proveedores o servicios.",
                            },
                        },
                    ],
                },
            ],
            onClick: () => navigate("/accounting/incomes-expenses"),
        },
        {
            id: "cashbox",
            title: "Apertura y cierre de caja",
            background: "#EDEEFC",
            onClick: () => handleOpen("cashbox"),
        },
        {
            id: "inventory-movement",
            title: "Movimiento de inventario",
            background: "#E6F1FD",
            dropdownItems: [
                {
                    group: [
                        { label: "Inventario", onClick: () => navigate("/accounting/inventory-movement") },
                    ],
                },
            ],
            onClick: () => handleOpen("inventory"),
        },
        {
            id: "client-statement",
            title: "Cuentas por cobrar",
            onClick: () => navigate("/accounting/client-statement"),
        },
        {
            id: "new-product",
            title: "Nuevo producto inventario",
            background: "#EDEEFC",
            disabled: !isCashboxOpen,
            onClick: () => handleOpen("product"),
        },
        {
            id: "partner-loan",
            title: "Préstamo a Socio",
            background: "#E6F1FD",
            disabled: !isCashboxOpen,
            dropdownItems: [
                {
                    group: [
                        {
                            label: "Descargar Informe",
                            onClick: actions.downloadPartnerReport,
                        },
                    ],
                },
            ],
            onClick: () => handleOpen("partner"),
        },
    ];
};

export default getActionCards;
